import { render, staticRenderFns } from "./ExamRandomAnalysis.vue?vue&type=template&id=fa585b3e&"
import script from "./ExamRandomAnalysis.vue?vue&type=script&lang=js&"
export * from "./ExamRandomAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports